import React from 'react';
import { FOOTER_PHONE, FOOTER_PHONE_HREF, FOOTER_SITE } from '../constants';
import { IconGlobe, IconPhone } from './ChatIcons';

export default function ChatFooter() {
  return (
    <div className="chatbox-footer">
      <a className="chatbox-footer-link" href={FOOTER_PHONE_HREF}>
        <IconPhone />
        <span>{FOOTER_PHONE}</span>
      </a>
      <span className="chatbox-footer-dot" aria-hidden="true" />
      <a className="chatbox-footer-link" href={FOOTER_SITE} target="_blank" rel="noopener noreferrer">
        <IconGlobe />
        <span>dpshtrr.al</span>
      </a>
    </div>
  );
}
